import { Helmet } from "react-helmet-async";

const SITE_URL = "https://therentify.com";

interface SEOProps {
  title: string;
  description: string;
  path?: string;
  type?: "website" | "article" | "product";
  image?: string;
  jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

/**
 * Per-route SEO head tags. Renders title, description, canonical, og:* tags, and optional JSON-LD.
 */
export const SEO = ({ title, description, path, type = "website", image, jsonLd }: SEOProps) => {
  const pathname = path ?? (typeof window !== "undefined" ? window.location.pathname : "/");
  const url = `${SITE_URL}${pathname}`;
  const desc = description.length > 160 ? description.slice(0, 157).trimEnd() + "…" : description;
  const schemas = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={image} />}
      {schemas.map((schema, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(schema)}</script>
      ))}
    </Helmet>
  );
};

export default SEO;
